import { Filesystem, Directory } from '@capacitor/filesystem'
import { FileOpener } from '@capacitor-community/file-opener'
import { saveAs } from 'file-saver'

export const convertBlobToBase64 = (blob: Blob) : Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onerror = reject
        reader.onload = () => {
            resolve((<string>reader.result).split(',')[1])
        }
        reader.readAsDataURL(blob)
    })


export const convertBase64ToFile = (base64String: string, fileName: string) => {
    const bstr = atob(base64String)
    let n = bstr.length
    const uint8Array = new Uint8Array(n)

    while (n--)
        uint8Array[n] = bstr.charCodeAt(n)

    return new File([uint8Array], fileName);
}

export const convertUrlToBlob = async (url: string): Promise<Blob> => {
    const response = await fetch(url)
    return await response.blob()
}

export const convertPathToBase64 = async (path: string): Promise<string | ArrayBuffer | null> => {
    const blob = await convertUrlToBlob(path)
    return await convertBlobToBase64(blob)
}

export const humanFileSize = (size: number): string => {
    const i = Math.floor( Math.log(size) / Math.log(1024) );
    const value = Number((size / Math.pow(1024, i)).toFixed(2))
    const suffix = ['B', 'kB', 'Mb', 'Gb', 'Tb'][i]

    return `${value} ${suffix}`
}

export const getExtension = (filename: string): string | undefined => filename.split('/').pop()?.split('.').pop()?.toLowerCase()

export const saveFileWeb = async (filename: string, data: string) => {
    const blob = convertBase64ToFile(data, filename)
    saveAs(blob)
}

export const saveFileNative = async (filename: string, data: string): Promise<string> => {
    const { uri } = await Filesystem.writeFile({
        path: filename,
        data: data,
        directory: Directory.Cache
    })

    return uri
}

export const openFile = async (path: string) => {
    await FileOpener.open({ filePath: path })
}
